module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0140.jpg?v=bb50b47a";